import { Grid } from "@mui/material";
import React from "react";
import NavigationDrawer from "../../components/navigationDrawer";
import MessageBox from "./MessageBox";

function ChatBooking() {
  return (
    <NavigationDrawer>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MessageBox />
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
}

export default ChatBooking;
